import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/sharing.svg'
import { Actor } from './Actor'
import { useModals } from 'almanac-ui/Modal'
import { ShareSheet } from 'components/ShareSheet/ShareSheet'
import { ActivityEventPosition, GrantArticleAccessEvent } from './Types'

interface Props extends ActivityEventPosition {
  event: GrantArticleAccessEvent
}

const GrantArticleAccess = ({ event, ...props }: Props) => {
  const { user, data, article } = event
  const { invitee } = data
  const { name, email, id } = invitee
  const { openModal: openNewShareModal } = useModals()

  const handleClick = (e: MouseEvent) => {
    e.stopPropagation()

    openNewShareModal(ShareSheet, {
      file: {
        id: article.key,
        type: 'article',
      },
    })
  }

  return (
    <BaseActivityEvent
      {...props}
      onClick={handleClick}
      icon={<Icon />}
      timestamp={event.timestamp}
      content={
        <>
          <Actor displayName={user.display_name || 'Anonymous User'} userId={user?.id} /> shared this doc with{' '}
          <Actor displayName={name || email} userId={id} />
        </>
      }
    />
  )
}

export { GrantArticleAccess }
